const AppConstants = {
  VALIDATION_PHASE_ONE: 1
}

export default AppConstants;